import type { OsasResendPatientInviteCustomControlData } from '@common/validation/customControls/osas/osasResendPatientInviteSchema';
import { CustomControlCode } from '@common/enums';
import { CustomControlRegistry } from '@frontend/components/pages/episodeCategory/customControls/customControlRegistry';
import { initialData } from '@frontend/components/pages/episodeCategory/customControls/osas/osasResendPatientInvite/osasResendPatientInviteData';
import { OsasResendPatientInviteEdit } from '@frontend/components/pages/episodeCategory/customControls/osas/osasResendPatientInvite/OsasResendPatientInviteEdit';
import { OsasResendPatientInviteRead } from '@frontend/components/pages/episodeCategory/customControls/osas/osasResendPatientInvite/OsasResendPatientInviteRead';

CustomControlRegistry.instance.register<OsasResendPatientInviteCustomControlData>({
    EditElement: OsasResendPatientInviteEdit,
    ReadElement: OsasResendPatientInviteRead,
    code: CustomControlCode.OSASResendMijnKsyosPatientInvite,
    initialData,
    version: 1,
});
